module.exports = __webpack_public_path__ + "images/c370faa41655540fdab1f5dc2f441ddf.png";